import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
// import { auth } from 'helpers/Firebase';
import axios from 'assets/remote/axios';
import { panelRoot, currentUser } from 'constants/defaultValues';
import { setCurrentUser } from 'helpers/Utils';
import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  OTP_SEND_CODE,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';

import {
  loginUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
  otpSendSuccess,
  otpSendError,
  resetData,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
  changeMobile,
} from './actions';
import { getHomePath } from 'helpers/authHelper';
import { NotificationManager } from 'components/common/react-notifications';
import { mukebs } from 'redux/mukeb/actions';

function* errorHandler(error) {
  if ('response' in error) {
    const keys = Object.keys(error?.response?.data?.errors);
    // eslint-disable-next-line no-restricted-syntax
    for (const item of keys)
      yield put(loginUserError(error?.response?.data?.errors[item][0]));
    yield put(loginUserError(''));
  } else {
    yield put(registerUserError(error.message));
    yield put(loginUserError(''));
  }
}

export function* watchSendOtp() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(OTP_SEND_CODE, sendOtpWithMobile);
}

const sendOtpWithMobileAsync = async (mobile) => {
  try {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    const res = await axios.post('/send_otp', { mobile });
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

function* sendOtpWithMobile({ payload }) {
  const { mobile } = payload;
  try {
    const response = yield call(sendOtpWithMobileAsync, mobile);
    if ('seconds' in response && response?.success) {
      yield put(otpSendSuccess(response?.message, response?.seconds));
    } else if ('seconds' in response && !response?.success) {
      yield put(otpSendSuccess(response?.message, response?.seconds));
      yield put(loginUserError(''));
    } else {
      yield put(otpSendError(response?.message ?? 'خطای ورود'));
      yield put(loginUserError(response?.message ?? 'خطای ورود'));
    }
  } catch (error) {
    yield put(otpSendError(error ?? 'خطا', 0));
    yield put(loginUserError(''));
  }
}

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(LOGIN_USER, loginWithOTP);
}

const loginWithOTPAsync = async (mobile, code) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL
  // eslint-disable-next-line no-return-await
  return (await axios.post('/verify', { mobile, code }))?.data;
}

const checkRoles = (roles, userRoles) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const role of roles) {
    if (userRoles.includes(role)) return true;
  }
  return false;
};

function* loginWithOTP({ payload }) {
  const { mobile, password } = payload.user;
  const { history } = payload;
  try {
    const loginUser = yield call(loginWithOTPAsync, mobile, password);
    const item = { token: loginUser.token, ...loginUser.data };
    setCurrentUser(item);
    yield put(loginUserSuccess(item));

    history.push(getHomePath(item));
  } catch (error) {
    if ('response' in error) {
      const keys = Object.keys(error?.response?.data?.errors);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of keys)
        yield put(loginUserError(error?.response?.data?.errors[item][0]));
    } else {
      yield put(registerUserError(error.message));
    }
  }
}

export function* watchRegisterUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(REGISTER_USER, registerWithUser);
}

const registerWithUserAsync = async (user) => {

  axios.defaults.baseURL = process.env.REACT_APP_API_URL
  // eslint-disable-next-line no-return-await
  return axios.post('/register', user);
  // await auth
  //   .createUserWithEmailAndPassword(email, password)
  //   .then((user) => user)
  //   .catch((error) => error);
}

function* registerWithUser({ payload }) {
  const user = payload.user;
  const { history } = payload;
  try {
    const response = yield call(registerWithUserAsync, user);
    yield put(registerUserSuccess(response.data));
    yield put(resetData());
    yield put(changeMobile(user.mobile));
    history.push(panelRoot);
  } catch (error) {

    if ('response' in error) {
      const keys = Object.keys(error?.response?.data?.errors ?? {});

      if (keys.length == 0) {
        yield put(registerUserError(error?.response?.data?.message));
      } else {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of keys) {
          const error_message = error?.response?.data?.errors[item][0];
          if (item === 'mobile' && error_message == 'شماره موبایل قبلا انتخاب شده است.') {
            yield put(changeMobile(user.mobile));
            history.push(panelRoot);
          } else {
            yield put(loginUserError(error_message));
          }
        }
      }

    } else {
      yield put(registerUserError(error.message));
    }
  }
  // try {
  //   const registerUser = yield call(
  //     registerWithEmailPasswordAsync,
  //     email,
  //     password
  //   );
  //   if (!registerUser.message) {
  //     const item = { uid: registerUser.user.uid, ...currentUser };
  //     setCurrentUser(item);
  //     yield put(registerUserSuccess(item));
  //     history.push(panelRoot);
  //   } else {
  //     yield put(registerUserError(registerUser.message));
  //   }
  // } catch (error) {
  //   yield put(registerUserError(error));
  // }
}

export function* watchLogoutUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeLatest(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  // await auth
  //   .signOut()
  //   .then((user) => user)
  //   .catch((error) => error);
  history.push(panelRoot);
};

function* logout({ payload }) {
  const { history } = payload;
  yield put(mukebs([]));
  setCurrentUser();
  yield call(logoutAsync, history);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchSendOtp),
    // fork(watchForgotPassword),
    // fork(watchResetPassword),
  ]);
}
